module.exports = __webpack_public_path__ + "img/4.04.thmb.b31e0d87.jpg";